import React, { useState } from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { leagueAttendanceStore } from 'state/league/leagueAttendance'
import CreateRollCall from 'pages/Events/Tabs/Attendances/Modals/RollCall/content/CreateRollCall'
import LeagueRollCallSelectAttendees from './LeagueRollCallSelectAttendees'

const LeagueRollCallModal: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { rollCallModalOpen, setRollCallModalOpen } = leagueAttendanceStore(store => ({
    rollCallModalOpen: store.rollCallModalOpen,
    setRollCallModalOpen: store.setRollCallModalOpen,
  }))
  const [current, setCurrent] = useState(0)
  const [payload, setPayload] = useState<any>()

  const closeModal = () => {
    setRollCallModalOpen(false)
    setCurrent(0)
  }

  const handleBack = () => {
    if (current === 0) closeModal()
    else setCurrent(current - 1)
  }

  return (
    <CustomModal
      openModal={rollCallModalOpen}
      closeModal={closeModal}
      title="Create Roll-call"
      width={1200}
      footer={
        <CustomModalFooter
          multibutton
          btnText={current === 0 ? 'Cancel,Next' : 'Back,Submit'}
          btnAlignment="justify-between"
          onSubmit={handleSubmit}
          closeModal={handleBack}
        />
      }
    >
      {current === 0 && (
        <CreateRollCall form={form} setPayload={setPayload} setCurrent={setCurrent} />
      )}
      {current === 1 && (
        <LeagueRollCallSelectAttendees payload={payload} form={form} closeModal={closeModal} />
      )}
    </CustomModal>
  )
}

export default LeagueRollCallModal
